import i18next from '../i18n';
export class AxFormValidation {
    constructor(options) {
        this.selector = options.selector;
        this.rules = options.rules;
        this.messages = options.messages;
        this.callBack = options.callback;
    }
    init() {
        $.validator.messages.required = i18next.t('form.required');
        /**
         * Client side form validation
         * Using Jquery Validation plugin
         * src: https://jqueryvalidation.org/
         *
         * @param   {[type]}  .ax-form  [.ax-form description]
         * @param   {[type]}  function  Form validation
         *
         * @return  {[type]}            error rule and message
         */
        $(this.selector).each((i, e) => {
            var _a;
            $(e).validate({
                errorClass: "field-error",
                ignore: "",
                focusInvalid: false,
                rules: this.rules,
                messages: (_a = this.messages) !== null && _a !== void 0 ? _a : this.getMessages(),
                submitHandler: (form) => {
                    if (this.callBack != null) {
                        this.callBack(form);
                        return;
                    }
                    form.submit();
                },
                invalidHandler: (event, validator) => {
                    this.invalidHandler();
                },
                errorPlacement: function (error, element) {
                    error.appendTo(element.parents(".ax-form-group"));
                    if (".ax-phone-field") {
                        error.appendTo(element.parents(".ax-phone-field"));
                    }
                    if (element.is(":checkbox")) {
                        error.appendTo(element.parents(".ax-checkbox-wrapper"));
                    }
                    if (element.is(":radio")) {
                        error.appendTo(element.parents(".ax-radio-wrapper"));
                    }
                },
            });
        });
    }
    getMessages() {
        return {
            checkbox: i18next.t('form.msgRadioCheck'),
            checkboxMd: i18next.t('form.msgRadioCheck'),
            checkboxMulti: i18next.t('form.msgRadioCheck'),
            checkboxMultiMd: i18next.t('form.msgRadioCheck'),
            radio: i18next.t('form.msgRadioCheck'),
            radioMd: i18next.t('form.msgRadioCheck'),
            inputName: i18next.t('form.required'),
            dropdown: i18next.t('form.msgDropdown'),
            hiddenPhone: {
                regex: i18next.t('form.msgPhoneRequired'),
            },
            email: {
                email: i18next.t('form.msgEmail'),
                regex: i18next.t('form.msgEmail')
            },
            emailguestconfirm: {
                required: true,
                equalTo: i18next.t('form.msgEmailGuestConfirm'),
            },
        };
    }
    invalidHandler() {
        $(".ax-dropdown").each(function () {
            if (!$(this).find(".hidden-input").val()) {
                if ($(this).find(".hidden-input").val() === "") {
                    $(this)
                        .find(".ax-dropdown__trigger")
                        .addClass("has-error");
                }
                else {
                    $(this)
                        .find(".ax-dropdown__trigger")
                        .parent()
                        .removeClass("has-error");
                }
            }
            else {
                $(this).find("label.field-error").hide();
                $(this)
                    .find(".ax-dropdown__trigger")
                    .parent()
                    .removeClass("has-error");
            }
            if (!$(this).find(".ax-form-group input").val()) {
                $(this)
                    .find(".ax-form-group input")
                    .addClass("field-error");
            }
            if ($(this).find("field-error")) {
                $(this)
                    .find(".ax-form-group input")
                    .removeClass("valid")
                    .addClass("field-error");
                $(this).find(".ax-form-group .la-check").remove();
            }
        });
    }
}
$.validator.addMethod(
/* The value you can use inside the object in the validator. */
"regex", 
/* The function that tests a given string against a given regEx. */
function (value, element, regexp) {
    /* Check if the value is truthy (avoid null.constructor) & if it's not a RegEx. (Edited: regex --> regexp)*/
    if (regexp && regexp.constructor != RegExp) {
        /* Create a new regular expression using the regex argument. */
        regexp = new RegExp(regexp);
    }
    else if (regexp.global)
        regexp.lastIndex = 0;
    /* Check whether the argument is global and, if so set its last index to 0. */
    /* Return whether the element is optional or the result of the validation. */
    return (this.optional(element) ||
        regexp.test(value));
});
$.validator.addMethod("pwcheck", function (value, element) {
    let password = value;
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%&!\.\(\)\{\}\[\]\^\$\*\+\-\?\/\|\—\/])(.{8,20}$)/.test(password)) {
        return false;
    }
    return true;
}, function (value, element) {
    let password = $(element).val();
    if (!/^(.{8,20}$)/.test(password)) {
        return i18next.t('form.msgPasswordInvalid');
    }
    else if (!/^(?=.*[A-Z])/.test(password)) {
        return i18next.t('form.msgPasswordUppercase');
    }
    else if (!/^(?=.*[a-z])/.test(password)) {
        return i18next.t('form.msgPasswordLowercase');
    }
    else if (!/^(?=.*[0-9])/.test(password)) {
        return i18next.t('form.msgPasswordDigit');
    }
    else if (!/^(?=.*[@#$%&!\.\(\)\{\}\[\]\^\$\*\+\-\?\/\|\—\/])/.test(password)) {
        return i18next.t('form.msgPasswordSpecChar');
    }
    return false;
});
